<template>

    <div class="mt-2">

        <div v-for="(document, index) in documents" class="card p-4 shadow" :class="index > 0 ? 'mt-3' : 'mb-3'">

            <!-- Render a custom view -->
            <div v-if="view.layout && view.layout.rows">
                <div v-for="(row, index) in view.layout.rows">
                    <row-renderer :layout="view.layout" :key="index + view.id + 'row'"
                                  :row="row" :index="index" :document="document" :table="table"
                                  :view="view"></row-renderer>
                </div>

                <list-item-actions v-if="model.viewModel.renderType !== 'Mobile' && isAuthorized(document)" :table="table" :document="document"
                                   :include-open="true"
                                   :parent-table="parentTable" :parent-document="parentDocument"
                                   :class="'d-flex'"></list-item-actions>
            </div>

            <!-- Render a static default view -->
            <list-item v-else :table="table" :document="document" :parent-document="parentDocument"
                       :parent-table="parentTable" @documentDeleteClick="onDeleteClick"></list-item>
        </div>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteDocument"
                text="Are you sure you want to delete this data?">
        </confirm-modal>

    </div>

</template>

<script>
    import ModelService from "../../services/ModelService";
    import ArrayUtil from "../../utils/ArrayUtil";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ListItem from "./ListItem.vue";
    import ViewHeader from "../ViewHeader.vue";
    import DataService from "../../services/DataService";
    import ListItemActions from "../../components/ListItemActions.vue";

    export default {
        name: 'ListView',
        components: {
            ListItemActions,
            ViewHeader,
            ListItem,
            ConfirmModal
        },
        props: {
            view: Object,
            table: Object,
            viewModel: Object,
            parentTable: Object,
            parentDocument: Object,
            viewConfig: Object,
            documents: Array
        },
        data() {
            return {
                model: webase.model,
                service: new ModelService(),
                dataService: new DataService(this.table.id),
                arrayUtil: new ArrayUtil(),
                // records: [],
                showConfirmModal: false,
                deleteDocument: function () {
                }
            }
        },
        computed: {
            isChildList() {
                return this.parentTable && this.parentDocument ? true : false
            },
            currentView() {
                return this.view || this.table.views[0]
            },
            // authorized() {
            //     return webase.managers.permission.fullAccess() || webase.managers.permission.authorized(this.parentTable, this.parentDocument)
            // },
            parentTableId() {
                return this.parentTable ? this.parentTable.id : null
            },
            parentDocumentId() {
                return this.parentDocument ? this.parentDocument['id'] : null
            }
        },
        mounted() {
            // if (this.view) {
            //     this.loadDataFromView()
            // } else {
            //     this.loadDataFromTable()
            // }

            webase.eventDispatcher.on('viewUpdated', this.handleViewUpdate)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.handleViewUpdate)
        },
        methods: {
            // loadDataFromTable() {
            //     if (this.parentDocument) {
            //         this.loadChildData()
            //     } else {
            //         this.loadDocuments()
            //     }
            // },
            // loadDataFromView() {
            //     let viewService = new ViewService()
            //     let relatedField = null
            //
            //     if (this.table && this.parentTable) {
            //         relatedField = webase.utils.table.getRelatedField(this.table, this.parentTable.system_id)
            //     }
            //
            //     viewService.getData(this.view, this.table, this.parentDocumentId, relatedField).then((response) => {
            //         this.records = response
            //     }).catch((message) => {
            //         console.log('error loading data from table')
            //         console.log(message)
            //     })
            // },
            // loadDocuments() {
            //     this.dataService.get().then((response) => {
            //         this.records = response
            //     }).catch((message) => {
            //         console.log('error loading dat from table')
            //         console.log(message)
            //     })
            // },
            // loadChildData() {
            //     this.dataService.get(this.parentDocumentId).then((response) => {
            //         this.records = response
            //     }).catch((message) => {
            //         console.log('error loading table')
            //         console.log(message)
            //     })
            // },
            onDeleteClick(document) {
                this.showConfirmModal = true
                this.deleteDocument = () => {
                    this.dataService.remove(document).then((response) => {
                        this.showConfirmModal = false
                        this.arrayUtil.remove(this.records, document['id'])
                    }).catch((message) => {
                        console.log('error deleting document')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },
            handleViewUpdate(view) {
                // if (this.view.id === view.id) {
                //     this.loadDataFromView()
                // }
            },
            isAuthorized(document) {
                if (webase.managers.permission.fullAccess()) {
                    return true
                }

                return webase.managers.permission.isAuthorized(this.table, document, this.parentTable, this.parentDocument)
            }
        }
    }
</script>

<style>

</style>
